import type { CatalogueEntry } from "../types";
import imageLight from "../images/national-wards.light.webp";
import imageDark from "../images/national-wards.dark.webp";

export const entry: CatalogueEntry = {
  slug: "national-wards",
  displayName: `National Wards`,
  datasetProductCode: `GEOSCAPE WARDS`,
  subtitle: `Detailed Mapping of Local Government Wards`,
  shortDescription: `Wards is a spatial representation of the gazetted ward districts, which are a subset of Local Government Area boundaries defined by the State and Territory governments of Australia. Not all Local Government Areas consist of Wards. Wards aggregates the representations unique to each jurisdiction into a consistent, seamless representation of the ward boundaries across Australia.This information is essential for understanding local governance structures and enhancing electoral and planning processes. This dataset supports decision-making for local governments, electoral bodies, and urban planners, facilitating community representation and strategic development.`,
  metadata: {
    dateAdded: 1630332000000,
    dataType: ["Polygons"],
    totalFeatureCount: 1523,
    updateFrequency: `Quarterly`,
    license: `CC BY 4.0`,
    metadataXml: `[ISOexample/19139](https://geoscape.com.au/)`,
    metadataJson: `[ISOexample/19139](https://geoscape.com.au/)`,
  },
  latestReleaseReportLink: `https://docs.geoscape.com.au/en/stable/wards.html`,
  productDescriptionLink: `https://docs.geoscape.com.au/en/stable/wards.html`,
  imageLight,
  imageDark,
  searchTags: `National Wards Geoscape Wards Mapping Ward Boundaries Political Divisions Civic Engagement Local Governance Urban Planning Community Mapping`,
  detail: () => import("../details/national-wards").then((m) => m.detail),
};

export default entry;
